import React, { useRef, useState, useEffect } from 'react'
import { useLocation } from 'react-router'

import useScrollUpdateHook from '../../utils/listeners/useScrollUpdateHook'
import SubBannerHeader from './SubBannerHeader'
import SubBannerContainer from './SubBannerContainer'
import Filler from '../utils/Filler'

const SubBanner: React.FC = () => {
  const rnRef = useRef<HTMLDivElement>(null)
  const subBannerRef = useRef<HTMLDivElement>(null)
  const location = useLocation()
  const [subBannerIsVisible, setSubBannerIsVisible] = useState(false)
  const { scrollDirection, marginTop, stick, height } = useScrollUpdateHook(
    rnRef,
    subBannerIsVisible,
  )
  const [topStick, setTopStick] = useState<{ value: number; top: string }>({
    value: 0,
    top: '-0px',
  })
  const [bottomStick, setBottomStick] = useState<{
    value: number
    bottom: string
  }>({ value: 0, bottom: '-0px' })
  const [marginTopStick, setMarginTopStick] = useState<{
    value: number
    marginTop: string
  }>({ value: 0, marginTop: '0px' })
  const [parentMinHeight, setParentMinHeight] = useState<{
    value: number
    minHeight: string
  }>({ value: 0, minHeight: '0px' })

  const isAtExploreRoute = location.pathname.split('/')[1] === 'explore'
  const currentYear = new Date().getFullYear()

  useEffect(() => {
    if (topStick.value !== stick) {
      setTopStick({ value: stick, top: `-${stick}px` })
    }

    if (bottomStick.value !== stick) {
      setBottomStick({ value: stick, bottom: `-${stick}px` })
    }

    if (marginTopStick.value !== marginTop) {
      setMarginTopStick({ value: marginTop, marginTop: `${marginTop}px` })
    }

    if (parentMinHeight.value !== height) {
      setParentMinHeight({ value: height, minHeight: `${height}px` })
    }
  }, [scrollDirection, marginTop, stick, height])

  useEffect(() => {
    // I actually don't remember what this one does, but since it is being passed to useScrollUpdateHook, I think this one checks if the sub banner is visible in the viewport because sub banner is responsive to screen sizes and won't show in mobile sized screens.. honestly I think I need to research this more because - wouldn't it matter if the component is unmounted? unmounted means not visible right XD so why do we need to check if it is visible at all times, why flag it if its not there...
    const observer = new IntersectionObserver(
      ([entry]) => {
        setSubBannerIsVisible(entry.isIntersecting)
      },
      {
        threshold: 0.1,
      },
    )

    if (subBannerRef.current) {
      observer.observe(subBannerRef.current)
    }

    return () => {
      if (subBannerRef.current) {
        observer.unobserve(subBannerRef.current)
      }
    }
  }, [])

  return (
    <div
      className="sb-main"
      // className="st:hidden slg:relative slg:w-[300px] slg:flex slg:flex-col slg:flex-auto lg:w-[350px]"
      style={parentMinHeight}
      ref={subBannerRef}
    >
      {/* BUFFER COMPONENT, WILL TAKE MARGIN TOP = TO DISTANCE COVERED THRU SCROLLING PAST REFERENCE COMPONENT HEIGHT OR BOTTOM */}
      <div
        // BUFFER COMPONENT
        className="relative"
        style={marginTopStick}
      ></div>
      <div
        // REFERENCE COMPONENT
        className="sticky inline h-auto pt-[50px]"
        style={scrollDirection === 1 ? bottomStick : topStick}
        ref={rnRef}
      >
        <div className="relative flex h-auto w-auto flex-col justify-start">
          {!isAtExploreRoute && <SubBannerHeader />}
          {/* <div className="sb-header flex hidden items-center text-xl font-semibold">
            <FaMagnifyingGlass size={28} className="ml-[10px]" />
            <h1 className="pl-[15px]">Explore</h1>
          </div> */}
          <div className="border-theme mt-[15px] rounded-2xl border">
            <div className="flex flex-col items-start gap-[7px] p-[15px]">
              <h1 className="flex text-xl font-bold">
                Subscribe to{' '}
                <span className="exile-regular flex items-center px-[5px]">
                  Y?
                </span>
                now!
              </h1>
              <p className="pb-[5px] text-base font-light tracking-tighter">
                To unlock amazing features, zero ads and to experience our
                newest features.{' '}
                <span className="font-bold">
                  ( Clicking the below will actually route you to X... )
                </span>
              </p>
              <button
                onClick={() => {
                  if (
                    confirm(
                      'Are you sure you want to move away from this page?',
                    )
                  ) {
                    window.location.href = 'https://www.x.com/'
                  }
                }}
                className="bgd-blue flex cursor-pointer items-center justify-center rounded-full px-[20px] py-[10px] text-sm text-white"
              >
                Join now!
              </button>
            </div>
          </div>
          <SubBannerContainer />
          {/* this is some sort of a band-aid solution for now. */}
          <h1 className="opacity-0">
            footerfooterfooterfooterfooterfooterfooterfooter
          </h1>
          <footer className="text-sub mt-[5px] h-[100px] w-full px-[20px] text-sm tracking-tighter">
            @ {currentYear}{' '}
            <a target="_blank" href="https://www.eabcdev.com">
              eabcdev.com
            </a>
          </footer>
        </div>
      </div>
    </div>
  )
}

export default SubBanner
